<template>
  <div class="freeTry">
      <el-dialog title="“Tip Biu BI”免費試用申請" :visible="visible" @update:visible="v => $emit('update:visible',v)" @close='cancel'>
        <div class="el-dialog-body">
            <div class="formSub" v-show="showForm">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
                    <el-form-item label="公司" prop="companyName">
                        <el-input v-model="ruleForm.companyName" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="ruleForm.name" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="部門別" prop="department" class="department">
                        <el-select v-model="ruleForm.department" placeholder="請選擇部門別">
                            <el-option label="董事長室/總經理室" value="董事長室/總經理室"></el-option>
                            <el-option label="財務部門" value="財務部門"></el-option>
                            <el-option label="銷售部門" value="銷售部門"></el-option>
                            <el-option label="企劃部門" value="企劃部門"></el-option>
                            <el-option label="行政部門" value="行政部門"></el-option>
                            <el-option label="研發部門" value="研發部門"></el-option>
                            <el-option label="人資部門" value="人資部門"></el-option>
                            <el-option label="客服部門" value="客服部門"></el-option>
                            <el-option label="採購部門" value="採購部門"></el-option>
                            <el-option label="資訊部門" value="資訊部門"></el-option>
                            <el-option label="倉管部門" value="倉管部門"></el-option>
                            <el-option label="品管部門" value="品管部門"></el-option>
                            <el-option label="製造/生產/廠務/生管部門" value="製造/生產/廠務/生管部門"></el-option>
                            <el-option label="稽核室" value="稽核室"></el-option>
                            <el-option label="門市" value="門市"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="職稱" prop="position">
                        <el-select v-model="ruleForm.position" placeholder="請選擇職稱">
                            <el-option label="(副)董事長/(副)總裁/(副)總經理" value="(副)董事長/(副)總裁/(副)總經理"></el-option>
                            <el-option label="顧問/督導/特助" value="顧問/督導/特助"></el-option>
                            <el-option label="協理/總監" value="協理/總監"></el-option>
                            <el-option label="經理/部長" value="經理/部長"></el-option>
                            <el-option label="副理/襄理" value="副理/襄理"></el-option>
                            <el-option label="（副）廠長" value="（副）廠長"></el-option>
                            <el-option label="（副）處長" value="（副）處長"></el-option>
                            <el-option label="（副）課長" value="（副）課長"></el-option>
                            <el-option label="專案經理" value="專案經理"></el-option>
                            <el-option label="主任/組長/科長" value="主任/組長/科長"></el-option>
                            <el-option label="專員/管理師/規劃師" value="專員/管理師/規劃師"></el-option>
                            <el-option label="資訊人員MIS/工程師" value="資訊人員MIS/工程師"></el-option>
                            <el-option label="稽核/會計" value="稽核/會計"></el-option>
                            <el-option label="店長" value="店長"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手機" prop="phone">
                        <el-input v-model="ruleForm.phone" auto-complete="off"/>
                    </el-form-item>
                    <el-form-item
                    prop="email"
                    label="郵箱"
                    :rules="[
                    { required: true, message: '請輸入郵箱地址', trigger: 'blur' },
                    { type: 'email', message: '請輸入正確的郵箱地址', trigger: ['blur', 'change'] }
                    ]">
                        <el-input v-model="ruleForm.email" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <p class="freeTryHint">請留下您的資訊，我們的服務人員將會儘快與您聯繫，為您介紹產品的功能亮點！</p>
            </div>
            <div class="successTry" v-show="!showForm">
                <img src="../../assets/img/success.png" />
                <ul>
                    <li>您已成功提交“Tip Biu BI”的免費試用申請！</li>
                    <li>我們將通過郵箱發送給您Tip Biu BI的帳號及密碼。</li>
                </ul>
                <div class="countDown">
                    <span>{{count}}s</span>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="cancel" v-if="!showForm">關閉</el-button>
            <el-button type="primary"  @click="submitForm('ruleForm')" v-loading="loading" v-if="showForm">預約提交</el-button>
            <!-- <a class="freeLogin" v-if="showForm">已有帳號？<a href="https://margin-demo.apps.digiwincloud.com/index.html#/account/login" target="_blank">立即登入</a></p> -->
        </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'FreeTry',
    props: {
      item: {},
      visible: false
    },
    watch: {
      visible(){
        if (this.visible) {
            this.showForm = true;
            this.resetForm('ruleForm'); 
        }
      }
    },
    data(){
      var checkPhone = (rule, value, callback) => {//手機號校驗
        if (value!='') {
          const reg = /^[1][3-8]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/
          //console.log(reg.test(value));
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('請輸入正確的手機號'));
          }
        }else{
            callback();
        }
      };
      return {
        showForm: true,
        ruleForm: {
          companyName: '',
          name: '',
          department: '',
          position: '',
          phone: '',
          email: ''
        },
        rules: {
          companyName: [
            { required: true, message: '請輸入公司名稱', trigger: 'blur' },
          ],
          name: [
            { required: true, message: '請輸入姓名', trigger: 'blur' },
          ],
          department: [
            { required: true, message: '請選擇部門別', trigger: 'change' },
          ],
          position: [
            { required: true, message: '請選擇職稱', trigger: 'change' }
          ],
          phone: [
            {validator: checkPhone, trigger: 'blur'}
          ]
        },
        count:'',
        timer: null,
        loading: false
      }
    },
    mounted() {
    },
    created(){
        
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log('submit!');
                    this.loading = true;
                    // 发送邮件
                    var that = this;
                    this.$http.post('/topbi/api/email', that.ruleForm, {headers: { "Content-Type": "application/json" }})
                    .then(function (response) {
                        that.loading = false;
                        if(response.data=='ok'){
                           that.saveToDatabase();
                        }else {
                            that.$message.info(response.data);
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
      },
      resetForm(formName) {//重置
        if (this.$refs[formName]!==undefined) {
            this.$nextTick(()=>{
                this.$refs[formName].resetFields();
            })   
        }
      },
      cancel() { // 取消
        this.$emit('update:visible',false);
        clearInterval(this.timer);
        this.timer = null;
      },
      setTime(num){//倒计时
        const TIME_COUNT = num;
        this.count = TIME_COUNT;
        if (!this.timer) {
            //this.count = TIME_COUNT;
            this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.$emit('update:visible',false);//彈框關閉
                }
            }, 1000)
        }
      },
      saveToDatabase() {//存入数据库
        var that = this;
        this.$http.post('/backend/web/companyInfo', that.ruleForm, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status==200){
                that.showForm = false;
                that.setTime(10);
            }
        })
        .catch(function (error) {
            console.log(error)
        });
      }

    }
  }
</script>
<style>
.freeTry .el-dialog{
    width: 628px;
    height: 390px;
    background: url(../../assets/img/tank.png) no-repeat center center;
    box-shadow: 0 1px 3px rgba(0,0,0,0);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0);
}
.freeTry .el-dialog__body{
    padding: 0 30px 20px;
}
.freeTry .el-dialog__header{
    text-align: center;
    padding: 60px 70px 10px 20px;
}
.freeTry .el-dialog__headerbtn{
    right: 35px;
}
.freeTry .el-dialog__title{
    font-size: 24px;
    color: #00AAFF;
}
.formSub{
    margin-top: 20px;
}
.freeTry .el-form{
    overflow: hidden;
}
.freeTry .el-form-item{
    float: left;
    width: 45%;
}
.freeTry .el-form-item__label{
    letter-spacing: 4px;
    line-height: 20px;
    padding: 0 10px 0 0;
}
.department .el-form-item__label{
    letter-spacing: 0px;
}
.freeTry .el-form-item__content{
    line-height: normal;
}
.freeTry .el-select{
    width: 100%;
}
.freeTry .el-input__suffix{
    right: 0;
}
.freeTry .el-input{
    /* width: 150px; */
    width: 100%;
    font-size:12px;
}
.freeTry .el-input__inner{
    border: 0;
    border-bottom: #000 1px solid;
    border-radius: 0px;
    color: #000;
    padding:0; 
    height: 20px;
    line-height: 20px;
}
.freeTry .el-input--suffix .el-input__inner{
    padding-right: 0;
}
.freeTry .el-select .el-input .el-select__caret{
    color: #000;
}
.freeTryHint{
    color: red;
    font-size: 12px;
    padding: 0 0 0 20px;
    text-indent: 25px;
}
.freeTry .el-dialog__footer{
    text-align: center;
    padding: 0 80px 20px 20px;
}
.freeTry .el-input__icon{
    line-height: 20px;
}
.freeTry .el-button{
    width: 150px;
    height: 32px;
    line-height: 32px;
    padding: 0; 
    border-radius: 50px;
    -moz-border-radius: 50px;
    -webkit-border-radius: 50px;
    border: 0;
    background: #00d4ff; /* Old browsers */
    background: -moz-linear-gradient(top,  #00d4ff 1%, #00c4ff 50%, #00abff 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  #00d4ff 1%,#00c4ff 50%,#00abff 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  #00d4ff 1%,#00c4ff 50%,#00abff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00d4ff', endColorstr='#00abff',GradientType=0 ); /* IE6-9 */

}
.successTry{
    text-align: center;
    margin-right: 60px;
}
.successTry ul li{
    margin-top:5px;
}
.countDown{
    text-align:center;
    margin-top: 10px;
}
.countDown span{
    display:inline-block;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border: #8D979B 1px solid;
    color: #000;
    border-radius: 100%;
    -moz-border-radius: 100%;
    -webkit-border-radius: 100%;
}
.freeLogin{
    display: inline-block;
    margin-left: 10px;
}
.freeLogin a{
    color: #00AAFF!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FreeTry.vue